import {FC} from 'react'
import {Header} from './welcome/Header'
import {Hero} from './welcome/Hero'
import {Services} from './welcome/Services'
import {Locations} from './welcome/Locations'
import {Reviews} from './welcome/Reviews'
import {Footer} from './welcome/Footer'

export const WelcomePageTheme3: FC = () => {
  return (
    <div className='welcomeTheme3'>
      <Header />
      <div className='welcomeTheme3-body default-width'>
        <Hero />
        <Services />
        <Locations />
        <Reviews />
      </div>
      <Footer />
    </div>
  )
}
